const CONFIG = {
  mapboxApiKey:
    'pk.eyJ1Ijoid2F0ZXItY29ycG9yYXRpb24iLCJhIjoiY2p3N2plM2hwMmY3bDQ5cGdtaG9yNGV5MCJ9.xERWE9qVS1lvH4FGGPZjEA',
};

export default CONFIG;
